export default __webpack_public_path__ + "static/media/icon_equal.d222f6a1.svg";